/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsRevoke } from "../funcs/agentsRevoke.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RevokeAgentRequest,
  RevokeAgentSecurity,
} from "../models/operations/revokeagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AgentsRevokeMutationVariables = {
  request: RevokeAgentRequest;
  security?: RevokeAgentSecurity | undefined;
  options?: RequestOptions;
};

export type AgentsRevokeMutationData = ManagedAgent;

export type AgentsRevokeMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * revoke agents
 */
export function useAgentsRevokeMutation(
  options?: MutationHookOptions<
    AgentsRevokeMutationData,
    AgentsRevokeMutationError,
    AgentsRevokeMutationVariables
  >,
): UseMutationResult<
  AgentsRevokeMutationData,
  AgentsRevokeMutationError,
  AgentsRevokeMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAgentsRevokeMutation(client, options),
    ...options,
  });
}

export function mutationKeyAgentsRevoke(): MutationKey {
  return ["@gram/client", "agents", "revoke"];
}

export function buildAgentsRevokeMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AgentsRevokeMutationVariables,
  ) => Promise<AgentsRevokeMutationData>;
} {
  return {
    mutationKey: mutationKeyAgentsRevoke(),
    mutationFn: function agentsRevokeMutationFn({
      request,
      security,
      options,
    }): Promise<AgentsRevokeMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsRevoke(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
